export default "__VITE_ASSET__2c21ba10__"